// file.type lo reporta el navegador: en Android/Chrome móvil suele venir 'image/jpg' o vacío para
// una foto real, así que se acepta también por extensión. El backend valida el contenido real.
export const isJpgOrPng = (file) => {
  if (!file) return false;
  const type = (file.type || '').toLowerCase();
  if (type === 'image/jpeg' || type === 'image/jpg' || type === 'image/png') return true;
  return /\.(jpe?g|png)$/i.test(file.name || '');
};

export const JPG_PNG_ACCEPT = 'image/jpeg,image/png,.jpg,.jpeg,.png';
